/* Desplegables nativos: fundido compartido y despliegue progresivo de las condiciones. */
(() => {
  'use strict';
  const motion = window.HotelMotion;
  if (!motion) return;
  const states = new Map();
  function followers(item) {
    const result = [];
    let node = item;
    while (node && !node.classList.contains('page')) {
      for (let next = node.nextElementSibling; next; next = next.nextElementSibling) {
        if (!next.hidden && !next.matches('script, style')) result.push(next);
      }
      node = node.parentElement;
    }
    return result;
  }
  function settle(item) {
    const state = states.get(item);
    if (!state) return;
    states.delete(item);
    motion.stop(state.body, 'fold');
    motion.stop(item, 'fold-size');
    item.open = state.expanded;
    if (state.resizing) { item.style.height = ''; item.style.overflow = ''; }
  }
  function toggle(item, expanded, event) {
    const body = item.querySelector('.rv-term-body, .faq-a');
    if (!body) { item.open = expanded; return; }
    const fromHeight = item.getBoundingClientRect().height;
    const opacity = item.open ? getComputedStyle(body).opacity : '0';
    const transform = item.open ? getComputedStyle(body).transform : 'translateY(-6px)';
    motion.stop(body, 'fold');
    motion.stop(item, 'fold-size');
    const state = { expanded, body, resizing: item.matches('.rv-term-item') };
    states.set(item, state);
    if (!motion.allowed(event)) { settle(item); return; }
    if (state.resizing) {
      // En textos largos, mover solo los elementos siguientes no evita el
      // salto del contenedor. Medimos ambos extremos una vez y liberamos la
      // altura al terminar; el contenido no se escala ni queda recortado.
      item.style.height = '';
      item.open = false;
      const collapsed = item.getBoundingClientRect().height;
      item.open = true;
      const target = expanded ? item.getBoundingClientRect().height : collapsed;
      item.style.height = fromHeight + 'px';
      item.style.overflow = 'hidden';
      const duration = expanded ? 220 : 170;
      motion.play(body, [
        { opacity, transform },
        { opacity: expanded ? 1 : 0, transform: expanded ? 'none' : 'translateY(-4px)' }
      ], { duration: expanded ? duration : 100, fill: 'forwards' }, 'fold');
      const animation = motion.play(item, [
        { height: fromHeight + 'px' }, { height: target + 'px' }
      ], { duration, fill: 'forwards' }, 'fold-size');
      animation.finished.then(() => {
        if (states.get(item) === state) settle(item);
      }, () => {});
      return;
    }
    const after = followers(item);
    if (expanded) {
      motion.flip(after, () => { item.open = true; }, event);
      const animation = motion.play(body, [
        { opacity, transform }, { opacity: 1, transform: 'none' }
      ], { duration: 220 }, 'fold');
      animation?.finished.then(() => { if (states.get(item) === state) settle(item); }, () => {});
    } else {
      // La salida acaba primero; después el espacio se recoge. Un nuevo clic
      // cancela esta fase y continúa desde la opacidad que ya se ve.
      const animation = motion.play(body, [
        { opacity, transform }, { opacity: 0, transform: 'translateY(-4px)' }
      ], { duration: 100, fill: 'forwards' }, 'fold');
      animation?.finished.then(() => {
        if (states.get(item) !== state) return;
        motion.flip(after, () => settle(item), event, 170);
      }, () => {});
    }
  }
  document.addEventListener('click', event => {
    const summary = event.target.closest('.rv-term-item > summary, .faq-item > summary');
    if (!summary) return;
    event.preventDefault();
    const item = summary.parentElement;
    toggle(item, !(states.get(item)?.expanded ?? item.open), event);
  });
  // Las anclas y cambios de página prevalecen sobre cualquier cierre pendiente.
  window.HotelAccordion = { open: item => { settle(item); item.open = true; } };
  window.addEventListener('hashchange', () => [...states.keys()].forEach(settle));
  motion.reduced.addEventListener('change', () => { if (motion.reduced.matches) [...states.keys()].forEach(settle); });
  window.addEventListener('resize', () => [...states.keys()].forEach(settle));
  document.addEventListener('i18n:change', () => [...states.keys()].forEach(settle));
})();

/* Servicios con foto de Inicio (2026-10-30): botones con aria-expanded/aria-controls que muestran su <figure>.
   Escritorio: una foto a la vez (selector). Móvil: acordeón, también una a la vez. El desayuno nace abierto en el HTML. */
(() => {
  'use strict';
  const raiz = document.querySelector('[data-svcf]');
  if (!raiz) return;
  const botones = [...raiz.querySelectorAll('.rd-svcf-btn')];
  const poner = (btn, abierto) => {
    const fig = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    if (fig) fig.hidden = !abierto;
  };
  raiz.addEventListener('click', e => {
    const btn = e.target.closest('.rd-svcf-btn');
    if (!btn || !raiz.contains(btn)) return;
    const abrir = btn.getAttribute('aria-expanded') !== 'true';
    const escritorio = window.matchMedia('(min-width: 861px)').matches;
    botones.forEach(b => { if (b !== btn) poner(b, false); });
    poner(btn, escritorio ? true : abrir);   // en escritorio siempre queda una foto visible
  });
})();
